import { useAuthStore } from '../store/auth';
import { Layout } from '../components/Layout';
import { PublicLayout } from '../components/PublicLayout';

// Content-Komponente für beide Layouts
export function ImpressumContent() {
  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Impressum</h1>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Angaben gemäß § 5 TMG</h2>
              <p>
                Michele Arcaro<br />
                Achterwaldstrasse 12<br />
                70794 Filderstadt<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Kontakt</h2>
              <p>
                E-Mail: info@dein-marketing-hub.de
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p>
                Michele Arcaro<br />
                Achterwaldstrasse 12<br />
                70794 Filderstadt
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Haftungsausschluss</h2>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Haftung für Inhalte</h3>
              <p className="text-sm">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
                Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Haftung für Links</h3>
              <p className="text-sm">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Urheberrecht</h3>
              <p className="text-sm">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

// Seite mit Auth-abhängigem Layout
export function ImpressumPage() {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return (
      <Layout>
        <ImpressumContent />
      </Layout>
    );
  }

  return (
    <PublicLayout>
      <ImpressumContent />
    </PublicLayout>
  );
}
